import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-RussianFederation",
  "use": "icon-RussianFederation-usage",
  "viewBox": "0 0 1536 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1536 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-RussianFederation\"><path d=\"M0 0h1536v320H0z\" fill=\"#FFFFFF\" p-id=\"40223\" /><path d=\"M0 320h1536v384H0z\" fill=\"#227FBB\" p-id=\"40224\" /><path d=\"M0 704h1536v320H0z\" fill=\"#E94B35\" p-id=\"40225\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol